type StructuredScriptsProps = {
  nonce?: string;
  breadcrumbFullUrl?: string;
  breadcrumbNames?: string[];
};

import { breadcrumbs } from "@forge42/seo-tools/structured-data/breadcrumb";

const LOCAL_BUSINESS = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "Công ty Cổ phần KLand",
  description:
    "Khám phá KLand, nền tảng môi giới bất động sản uy tín tại Việt Nam – giao dịch minh bạch, ký gửi nhanh, đầu tư thông minh và an toàn tuyệt đối.",
  sameAs: [
    "https://www.google.com/maps?cid=17840392669217710323",
    "https://www.facebook.com/kland.com.vn",
  ],
  image: [
    "https://apis-cms.kland.com.vn/api/v1/files/fff8e507-c416-4810-815b-9111c97428b8.jpg",
  ],
  address: {
    "@type": "PostalAddress",
    streetAddress: "43 Đ. Lý Thái Tổ, TDP Tân Quang 10",
    addressLocality: "Tuyên Quang",
    addressRegion: "TQ",
    postalCode: "22110",
    addressCountry: "VN",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: "21.813393598586455",
    longitude: "105.21123886380005",
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "07:30",
      closes: "17:30",
    },
  ],
  telephone: "+84975634828",
  url: "https://kland.com.vn/",
  priceRange: "$$",
  review: {
    "@type": "Review",
    author: {
      "@type": "Person",
      name: "Công Tuân",
    },
    reviewRating: {
      "@type": "Rating",
      ratingValue: "4.8",
      bestRating: "5",
    },
  },
};

const ORGANIZATION = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Công ty Cổ phần KLand",
  url: "https://kland.com.vn/",
  logo: "https://apis-cms.kland.com.vn/api/v1/files/fff8e507-c416-4810-815b-9111c97428b8.jpg",
  description:
    "Khám phá KLand, nền tảng môi giới bất động sản uy tín tại Việt Nam – giao dịch minh bạch, ký gửi nhanh, đầu tư thông minh và an toàn tuyệt đối.",
  sameAs: [
    "https://www.google.com/maps?cid=17840392669217710323",
    "https://www.facebook.com/kland.com.vn",
  ],
};

export function SeoStructuredScripts({
  nonce,
  breadcrumbFullUrl,
  breadcrumbNames,
}: StructuredScriptsProps) {
  const breadcrumbJson =
    breadcrumbFullUrl && typeof breadcrumbFullUrl === "string"
      ? breadcrumbs(breadcrumbFullUrl, breadcrumbNames)
      : null;

  return (
    <>
      <script
        type="application/ld+json"
        nonce={nonce}
        dangerouslySetInnerHTML={{ __html: JSON.stringify(LOCAL_BUSINESS) }}
      />
      <script
        type="application/ld+json"
        nonce={nonce}
        dangerouslySetInnerHTML={{ __html: JSON.stringify(ORGANIZATION) }}
      />
      {breadcrumbJson ? (
        <script
          type="application/ld+json"
          nonce={nonce}
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(breadcrumbJson),
          }}
        />
      ) : null}
    </>
  );
}

